import { useEffect } from "react";

const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined"
    ? window.location.origin
    : "https://muratoreimbianchinoroma.it");

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Client-side SEO manager: title, meta description/keywords, canonical,
 * Open Graph, Twitter Card and JSON-LD structured data.
 */
export default function useSEO({ title, description, keywords, path = "/", jsonLd = [] }) {
  useEffect(() => {
    const url = SITE_URL + path;
    if (title) document.title = title;
    if (description) {
      upsertMeta('meta[name="description"]', { name: "description", content: description });
      upsertMeta('meta[property="og:description"]', { property: "og:description", content: description });
      upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    }
    if (keywords) upsertMeta('meta[name="keywords"]', { name: "keywords", content: keywords });
    if (title) {
      upsertMeta('meta[property="og:title"]', { property: "og:title", content: title });
      upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    }
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: url });
    upsertMeta('meta[property="og:type"]', { property: "og:type", content: "website" });
    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsertLink("canonical", url);

    // JSON-LD (managed block, replaced on each route)
    const existing = document.head.querySelectorAll('script[data-seo-jsonld="true"]');
    existing.forEach((n) => n.remove());
    (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).filter(Boolean).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "true");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }, [title, description, keywords, path, jsonLd]);
}

export const localBusinessLd = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  name: "Muratore Imbianchino Roma",
  areaServed: "Roma",
  address: { "@type": "PostalAddress", addressLocality: "Roma", addressCountry: "IT" },
  priceRange: "€€",
};

export function faqLd(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function breadcrumbLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: SITE_URL + it.path,
    })),
  };
}
